module.exports = __webpack_public_path__ + "media/images/common/new_entry_btn-a9766199f2b9a3d40cc6e4f1ad0b92ea.png";